// Sign-in loop guard (as platform-fe): if Keycloak keeps sending the browser
// back (a token the API refuses), stop after one round trip per 60 s.
export const KC_SIGNIN_KEY = "kc_signin_at";
const WINDOW_MS = 60_000;

export function recentSignInAttempt(): boolean {
  try {
    const at = Number(sessionStorage.getItem(KC_SIGNIN_KEY));
    return Number.isFinite(at) && at > 0 && Date.now() - at < WINDOW_MS;
  } catch {
    return false;
  }
}

export function markSignInAttempt(): void {
  try {
    sessionStorage.setItem(KC_SIGNIN_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable: no loop guard, the redirect still works.
  }
}

// Called only once /api/me has succeeded, never on the callback alone.
export function clearSignInAttempt(): void {
  try {
    sessionStorage.removeItem(KC_SIGNIN_KEY);
  } catch {
    // ignore
  }
}

export type LoginAction = "home" | "redirect" | "button" | "legacy";

// What the login page does. Keycloak mode never shows a form: it goes to
// Keycloak (silent when a session exists), or shows one button after a
// recent attempt so a refused sign-in cannot loop.
export function loginAction(p: { keycloak: boolean; authenticated: boolean; recentAttempt: boolean }): LoginAction {
  if (!p.keycloak) return p.authenticated ? "home" : "legacy";
  if (p.recentAttempt) return "button";
  return p.authenticated ? "home" : "redirect";
}
